import { render, staticRenderFns } from "./Demir.vue?vue&type=template&id=32d958dc&scoped=true&"
import script from "./Demir.vue?vue&type=script&lang=js&"
export * from "./Demir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d958dc",
  null
  
)

export default component.exports